import React from 'react';
import "./pitchbookInsights.css";
import "../../common/css/component.css";

const PitchbookInsights = ({ portfolioInsights }) => {

  if (!portfolioInsights) {
    return null;
  }

  const insightsData = JSON.parse(portfolioInsights.insights);

  //Get Year Founded if available
  const yearFounded = insightsData.items.find(item => item.highlight === "YEAR_FOUNDED")?.date;

  //Get Total Raised if available
  const totalRaisedItem = insightsData.items.find(item => item.highlight === "TOTAL_RAISED_TO_DATE");
  let totalRaised = null;
  if (totalRaisedItem) {
    const currency = totalRaisedItem.totalMoneyRaised.currency || 'USD';
    const amount = totalRaisedItem.totalMoneyRaised.amount;
    totalRaised = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
  }

  //Get Post Valuation information
  const postValuationItem = insightsData.items.find(item => item.highlight === "POST_VALUATION");
  let postValuation = null;
  let postValuationDate = null;
  if (postValuationItem) {
    const currency = postValuationItem.amount.currency || 'USD';
    const amount = postValuationItem.amount.amount;
    postValuation = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
    postValuationDate = new Date(postValuationItem.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }

  //Get Employee count details
  const employeeCountItem = insightsData.items.find(item => item.highlight === "EMPLOYEES");
  let employeeCount = null;
  let employeeCountDate = null;
  if (employeeCountItem) {
    const latestCountPoint = employeeCountItem.chartPoints.reduce((latest, current) => {
      return new Date(current.currentDate) > new Date(latest.currentDate) ? current : latest;
    });
    employeeCount = latestCountPoint.count;
    employeeCountDate = new Date(latestCountPoint.currentDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }

  //Get VC Opportunity Score details
  const opportunityScoreItem = insightsData.items.find(item => item.highlight === "VC_OPPORTUNITY_SCORE");
  let opportunityScore = null;
  let totalCompaniesCount = null;
  if (opportunityScoreItem) {
    opportunityScore = opportunityScoreItem.opportunityScore;
    totalCompaniesCount = new Intl.NumberFormat('en-US').format(opportunityScoreItem.totalCompaniesCount);
  }

  //Get VC Exit Type details
  const vcExitTypeItem = insightsData.items.find(item => item.highlight === "VC_EXIT_TYPE");
  let exitType = null;
  let successProbability = null;
  if (vcExitTypeItem) {
    exitType = vcExitTypeItem.exitType;
    successProbability = vcExitTypeItem.success;
  }
  
  return (
    <div className="pitchbook-insights-container">
        <div className="pitchbook-insights-heading">Pitchbook Insights</div>
        {yearFounded && <p>Date Founded: <span>{new Date(yearFounded).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span></p>}
        {totalRaised && <p>Total Raised: <span>{totalRaised}</span></p>}
        {postValuation && <p>Post Valuation: <span>{postValuation}</span></p>}
        {postValuationDate && <p>Post Valuation Date: <span>{postValuationDate}</span></p>}
        {employeeCount && <p>No of Employees: <span>{employeeCount} (As of {employeeCountDate})</span></p>}
        {opportunityScore && totalCompaniesCount && <p>VC Exit Predictor Opportunity Score: <span>{opportunityScore} / 100 (Out of {totalCompaniesCount} companies with Opportunity Score)</span></p>}
        {exitType && successProbability && <p>VC Exit Predictor: <span>{exitType} ({successProbability}% probability)</span></p>}
    </div>
  );
};

export default PitchbookInsights;
